import styled from 'styled-components';

export const DefaultContainer = styled.div.withConfig({ componentId: 'sc-1ukyu1q-0' })`
  margin: 36px auto;
  text-align: left;
`;
